import dayjs from 'dayjs';

export const getPeriodCalc = (cal, commenceDate, maxPeriod) => {
  let map = {};
  let difference = cal.daysInMonth() - cal.date();
  let firstInstalmentDate = dayjs(
    `${cal.year()}-${cal.month() + 1}-${cal.daysInMonth() + 1}`, //!FIX
  );

  let installmentDate;

  if (difference < 15) {
    installmentDate = firstInstalmentDate.add(1, 'month');
  } else {
    installmentDate = firstInstalmentDate;
  }

  let expiryDate = installmentDate.add(maxPeriod - 1, 'month');
  let period = calcMonthsBetweenDates(expiryDate, commenceDate);

  map.noOfInstallments = maxPeriod;
  map.firstInstallmentDate = installmentDate;
  map.commencementDate = commenceDate;
  map.expiryDate = expiryDate;
  map.period = period;

  return map;
};

const calcMonthsBetweenDates = (expiryDate, commenceDate) => {
  let expiryTime = expiryDate.valueOf();
  let commenceTime = commenceDate.valueOf();

  return Math.ceil(
    (expiryTime - commenceTime) / (1000 * 60 * 60 * 24) / 30.436875,
  );
};
